import { AttributeValueContentType } from "../../AttributeValue/AttributeValueContentType";
import { ThumbnailActions } from "./ThumbnailActions";
import { ThumbnailContent } from "./ThumbnailContent";
import { ThumbnailImage } from "./ThumbnailImage";
import { ThumbnailInfo } from "./ThumbnailInfo";
export const thumbValueContentComponents = {
    [AttributeValueContentType.Help]: ThumbnailInfo,
    [AttributeValueContentType.Image]: ThumbnailImage,
    [AttributeValueContentType.Content]: ThumbnailContent,
    [AttributeValueContentType.Actions]: ThumbnailActions,
};
//# sourceMappingURL=thumbValueContentComponents.js.map